import { useQuery } from 'react-query';

import { apiClient } from 'api/apiClient';

export interface IPropertyCount {
    name: string;
    value: number;
}

export interface IProductsInfo {
    count: number;
    re_low: number;
    re_high: number;
    dist_lo: IPropertyCount[];
    dist_hi: IPropertyCount[];
}

export const fetchProducts = async (zip?: string): Promise<IProductsInfo> => {
    const response = await apiClient.get('products', {
        searchParams: { zip: zip ?? '' },
    });
    // eslint-disable-next-line @typescript-eslint/return-await
    return await response.json();
};

export const useGetProducts = ({ zip, ...options }: { zip?: string }) => {
    return useQuery(
        ['products', { zip }],
        async () => await fetchProducts(zip),
        {
            ...options,
        }
    );
};
